import React, { Component } from 'react';
import { connect } from "react-redux";
import { Row, Col, message, Checkbox, Select, Space, Form, Tooltip } from 'antd';
import intersection from 'lodash/intersection';
import difference from 'lodash/difference';
import { getLangList } from '@/lib/i18n';
import { ReButton, ReModal } from '@/components/refineElement';
import { getOptionArray, sortChineseColumn } from "@/lib/antdElementFunction";
import BusConfig from "@/config/bus";
import ResponsiveTable from '@/components/responsiveTable';
import { getUserAccountById, } from "@/stores/user/action";
import { ModalProfile } from "@/components/modal";
import { hasPermission } from "@/lib/permissionUtil";
import ModalStudent from './ModalStudent';

const { getStudentInfo, updateStudentStatus, updateStudentTakeBus } = BusConfig;

interface props {
  dispatch: any;
  activePathId: any,
  allStudentArray: any;
  getSchoolInfo: any;
  activeTimeArray: number[];
}

interface state {
  isModalVisible: boolean;
  handleType: string;
  studentArray: any;
}

class StudentList extends Component<props, state> {
  state = {
    isModalVisible: false,
    handleType: '',
    studentArray: [] as never as any,
  };
  busT: any = getLangList("bus");
  profileInfoT: any = getLangList("profileInfo");
  errorT: any = getLangList("error");
  formRef: any = React.createRef();
  autoRefresh: any;

  componentDidMount() {
    this.getStudentInfo();
    this.autoRefresh = setInterval(() => {
      this.getStudentInfo();
      this.props.getSchoolInfo();
    }, 60 * 1000);
  }

  componentWillUnmount() {
    clearInterval(this.autoRefresh);
  }

  getColumns = () => {
    const columns: any = [
      {
        title: () => {
          return (
            <Space>
              {this.busT.SIGN}

              <Checkbox checked={false} onChange={this.changeRollCallAll()} />
            </Space>
          );
        },
        dataIndex: "whetherRollCall",
        render: (text: boolean, record: any) => {
          const { leaveType, userAccountId, whetherTakeBus } = record;
          return (
            <Form.Item name={`whetherRollCall-${userAccountId}`} valuePropName='checked'>
              <Checkbox
                onChange={this.changeRollCall(record)}
                disabled={leaveType || !whetherTakeBus}
              />
            </Form.Item>
          );
        },
      },
      {
        title: this.busT.CN_NAME,
        dataIndex: "nameCn",
        sorter: {
          compare: (a: any, b: any) => sortChineseColumn(a.school, b.school),
          multiple: 2,
        },
        defaultSortOrder: 'ascend',
        sortDirections: [],
        sortOrder: "ascend",
        render: (text: string, record: any) => (
          <Tooltip title={`${record.school} ${this.getGradeDetail(record)}`}>
            {text}
          </Tooltip>
        )
      },
      {
        title: this.busT.EN_NAME,
        dataIndex: "nameEn",
        sorter: {
          compare: (a: any, b: any) => sortChineseColumn(this.getGradeDetail(a), this.getGradeDetail(b)),
          multiple: 1,
        },
        defaultSortOrder: 'ascend',
        sortDirections: [],
        sortOrder: "ascend",
        render: (text: string, record: any) => (
          <Tooltip title={`${record.school} ${this.getGradeDetail(record)}`}>
            {text}
          </Tooltip>
        )
      },
    ];

    hasPermission('BUS_DETAIL') && columns.push(
      {
        title: this.busT.CN_SCHOOL,
        dataIndex: "school",
      },
      {
        title: this.busT.CLASS_SITE_NO,
        dataIndex: "grade",
        render: (text: string, record: any) => this.getGradeDetail(record),
      },
      {
        title: this.busT.SITUATION,
        dataIndex: "whetherTakeBus",
        render: (text: boolean, record: any) => {
          const { leaveType, userAccountId } = record;
          return (
            <Form.Item name={`whetherTakeBus-${userAccountId}`}>
              <Select
                style={{ width: '100%' }}
                onChange={this.changeTakeBus(record)}
                disabled={leaveType}
              >
                {getOptionArray([
                  { label: this.busT.TAKE_RIDE, value: true },
                  { label: this.busT.NOT_TAKE_RIDE, value: false },
                ])}
              </Select>
            </Form.Item>
          );
        },
      },
      {
        title: this.busT.CONTACT,
        dataIndex: "contant",
        render: (text: string, record: any) => {
          return (
            <ReButton iconName='phone' attributeObject={{ type: "link" }} onClick={this.clickViewProfileInfo(record)} />
          );
        },
      },
    );

    return columns;
  };

  getGradeDetail = (record: any) => {
    const { grade, classroom, seatNumber } = record;
    return `${grade ?? '-'}${this.busT.GRADE}${classroom ?? '-'}${this.busT.CLASSROOM}${seatNumber ?? '-'}${this.busT.SEAT_NUMBER}`;
  }

  getUserAccountById = (userAccountId: string) => () => {
    const { dispatch } = this.props;
    const params = { userAccountId };

    dispatch(getUserAccountById(params));
  }

  changeTakeBus = (record: any) => (value: any) => {
    const { userAccountId, busTimeSchoolId } = record;
    const params = [{
      userAccountId,
      busTimeSchoolId,
      whetherTakeBus: value ? '1' : '0',
    }];

    this.updateStudentStatus(params);
  }

  changeRollCall = (record: any) => (e: any) => {
    const whetherRollCall = e.target.checked;
    const { userAccountId, busTimeSchoolId } = record;
    const params = [{
      userAccountId,
      busTimeSchoolId,
      whetherRollCall: whetherRollCall ? '1' : '0',
    }];

    this.updateStudentStatus(params);
  }

  changeRollCallAll = () => () => {
    const { studentArray } = this.state;
    const params = studentArray.map((item: any) => {
      const { userAccountId, busTimeSchoolId, leaveType } = item;
      return { userAccountId, busTimeSchoolId, whetherRollCall: leaveType ? '0' : '1' };
    })

    this.updateStudentStatus(params);
  }

  getStudentInfo = () => {
    const { activePathId, activeTimeArray } = this.props;
    const params = {
      busTimeSchoolId: activePathId,
      startTime: activeTimeArray[0],
      endTime: activeTimeArray[1],
    };

    getStudentInfo(params).then((res: any) => {
      const studentArray = res?.value ?? [];

      this.setFormWhetherRollCall(studentArray);
      this.setFormWhetherTakeBus(studentArray);
      this.setState({ studentArray });
    });
  }

  toggleModal = (handleType: string = '') => {
    const { isModalVisible } = this.state;
    this.setState({ isModalVisible: !isModalVisible, handleType });
  }

  clickViewProfileInfo = (data: any) => () => {
    const { userAccountId } = data;

    this.getUserAccountById(userAccountId)();
    this.toggleModal('viewProfileInfo');
  }

  setFormWhetherRollCall = (studentArray: any) => {
    studentArray.forEach((item: any) => {
      const { whetherRollCall, leaveType, userAccountId } = item;
      this?.formRef?.current?.setFieldsValue({ [`whetherRollCall-${userAccountId}`]: whetherRollCall && !leaveType });
    });
  }

  setFormWhetherTakeBus = (studentArray: any) => {
    studentArray.forEach((item: any) => {
      const { whetherTakeBus, userAccountId } = item;
      this?.formRef?.current?.setFieldsValue({ [`whetherTakeBus-${userAccountId}`]: whetherTakeBus });
    });
  }

  updateStudentStatus = (params: any) => {
    const { getSchoolInfo } = this.props;
    updateStudentStatus(params).then((res: any) => {
      if (!res.success) {
        return message.error(this.errorT.failed);
      }
      message.success(this.errorT.success);
      this.getStudentInfo();
      getSchoolInfo();
    });
  }

  updateStudentTakeBus = (values: any) => {
    const { activePathId, getSchoolInfo } = this.props;
    const { studentArray } = this.state;
    const { takeBusStudentKey } = values;
    const studentArrayKey = studentArray.map((item: any) => `${item.userAccountId}`);
    const intersectionKey = intersection(takeBusStudentKey, studentArrayKey);
    const addIds = difference(takeBusStudentKey, intersectionKey);
    const removeIds = difference(studentArrayKey, takeBusStudentKey);
    const params = {
      addIds,
      removeIds,
      busTimeSchoolId: activePathId,
    }

    updateStudentTakeBus(params).then((res: any) => {
      if (!res.success) {
        return message.error(this.errorT.failed);
      }
      message.success(this.errorT.success);
      this.toggleModal();
      this.getStudentInfo();
      getSchoolInfo();
    });
  }

  onClickRefresh = () => {
    this.getStudentInfo();
    this.props.getSchoolInfo();
  }

  render() {
    const { allStudentArray } = this.props;
    const { isModalVisible, studentArray, handleType } = this.state;
    const isShowModalProfileInfo = isModalVisible && handleType === 'viewProfileInfo';

    return (
      <>
        <Row gutter={[0, 8]}>
          <Col span={24}>
            <div className="re-button-container-right">
              <ReButton
                iconName="reload"
                onClick={this.onClickRefresh}
                attributeObject={{ type: 'link' }}
              />

              {hasPermission('BUS_EDIT') &&
                <ReButton iconName='edit' onClick={this.toggleModal}>
                  {this.busT.EDIT_TAKE_BUS_LIST}
                </ReButton>
              }
            </div>
          </Col>

          <Col span={24}>
            <Form ref={this.formRef} className="bus-school-form">
              <ResponsiveTable
                className="sort-no-background"
                dataSource={studentArray}
                columns={this.getColumns()}
                rowClassName={(record: any) => (record.leaveType || !record.whetherTakeBus) ? 'mark' : ''}
                displayScrollY={false}
              />
            </Form>
          </Col>
        </Row>

        {isModalVisible &&
          <ReModal
            title={this.busT.TIME}
            onCancel={() => this.toggleModal()}
            visible={isModalVisible}
            onOk={this.updateStudentTakeBus}
            CollectedForm={ModalStudent}
            formProps={{
              studentArray,
              allStudentArray,
            }}
            width={'700px'}
          />
        }

        {isShowModalProfileInfo &&
          <ReModal
            title={this.profileInfoT.PROFILE_INFO}
            onCancel={this.toggleModal}
            visible={isShowModalProfileInfo}
            onOk={this.toggleModal}
            CollectedForm={ModalProfile}
            formProps={{ handleType }}
            width={'700px'}
            Footer={null}
          />
        }
      </>
    );
  }
}

export default connect()(StudentList);